var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"WorkflowInvocationSteps"},_vm._l((_vm.models),function(step){return _c(_vm.WorkflowInvocationStep,{key:step.id,tag:"li",attrs:{"model":step}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }